export function stopOrPauseJob() {
  return {
    type: 'STOP_OR_PAUSE_JOB',
  };
}

export function requestContractor() {
  return {
    type: 'REQUEST_CONTRACTOR',
  };
}

export function closeContractorDialog() {
  return {
    type: 'CLOSE_CONTRACTOR_REQUEST',
  };
}

export function completeJob() {
  return {
    type: 'COMPLETE_JOB',
  };
}

export function closeJobDialog() {
  return {
    type: 'CLOSE_JOB_DIALOG',
  };
}
